import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  updateAddress: {
    loading: false,
    error: null,
    success: false,
    data: null,
  },
  appointmentSlots: {
    loading: false,
    error: null,
    success: false,
    slotsResponse: [],
  },
  createLabTestOrderState: {
    loading: false,
    error: null,
    success: false,
    data: null,
  },
  confirmOrderState: {
    loading: false,
    error: null,
    success: false,
    data: null,
  },
  getRecordsState: {
    loading: false,
    error: null,
    success: false,
    data: null,
  },
}

const diagnosticsSlice = createSlice({
  name: 'diagnostics',
  initialState,
  reducers: {
    // Update Address
    updateAddressRequest: (state, action) => {
      state.updateAddress = {
        ...state.updateAddress,
        loading: true,
        success: false,
        error: null,
      }
    },
    updateAddressSuccess: (state, action) => {
      state.updateAddress = {
        ...state.updateAddress,
        loading: false,
        success: true,
        error: null,
        data: action.payload,
      }
    },
    updateAddressError: (state, action) => {
      state.updateAddress = {
        ...state.updateAddress,
        loading: false,
        success: false,
        error: action.payload,
      }
    },

    // Get Appointment Slots
    getAppointmentSlotsRequest: (state, action) => {
      state.appointmentSlots = {
        ...state.appointmentSlots,
        loading: true,
        success: false,
        error: null,
      }
      state.updateAddress.success = false
    },
    getAppointmentSlotsSuccess: (state, action) => {
      state.appointmentSlots = {
        ...state.appointmentSlots,
        loading: false,
        success: true,
        error: null,
        slotsResponse: action.payload || [],
      }
    },
    getAppointmentSlotsError: (state, action) => {
      state.appointmentSlots = {
        ...state.appointmentSlots,
        loading: false,
        success: false,
        slotsResponse: [],
        error: action.payload,
      }
    },

    // Book Test
    createLabTestOrderRequest: (state, action) => {
      state.createLabTestOrderState = {
        ...state.createLabTestOrderState,
        loading: true,
        success: false,
        error: null,
      }
    },
    createLabTestOrderSuccess: (state, action) => {
      state.createLabTestOrderState = {
        ...state.createLabTestOrderState,
        loading: false,
        success: true,
        error: null,
        data: action.payload,
      }
    },
    createLabTestOrderError: (state, action) => {
      state.createLabTestOrderState = {
        ...state.createLabTestOrderState,
        loading: false,
        success: false,
        error: action.payload,
      }
    },

    confirmOrderRequest: (state, action) => {
      state.confirmOrderState = {
        ...state.confirmOrderState,
        loading: true,
        success: false,
        error: null,
      }
    },
    confirmOrderSuccess: (state, action) => {
      state.confirmOrderState = {
        ...state.confirmOrderState,
        loading: false,
        success: true,
        error: null,
        data: action.payload,
      }
    },
    confirmOrderError: (state, action) => {
      state.confirmOrderState = {
        ...state.confirmOrderState,
        loading: false,
        success: false,
        error: action.payload,
      }
    },

    // Get Records
    getRecordsRequest: (state, action) => {
      state.getRecordsState = {
        ...state.getRecordsState,
        loading: true,
        success: false,
        error: null,
      }
    },
    getRecordsSuccess: (state, action) => {
      state.getRecordsState = {
        ...state.getRecordsState,
        loading: false,
        success: true,
        error: null,
        data: action.payload,
      }
    },
    getRecordsError: (state, action) => {
      state.getRecordsState = {
        ...state.getRecordsState,
        loading: false,
        success: false,
        error: action.payload,
      }
    },
    resetRecordsState: (state, action) => {
      state.getRecordsState = {
        ...state.getRecordsState,
        loading: false,
        success: false,
        error: null,
        data: null,
      }
    },
  },
})

export const {
  updateAddressRequest,
  updateAddressSuccess,
  updateAddressError,
  getAppointmentSlotsRequest,
  getAppointmentSlotsSuccess,
  getAppointmentSlotsError,
  createLabTestOrderRequest,
  createLabTestOrderSuccess,
  createLabTestOrderError,
  confirmOrderRequest,
  confirmOrderSuccess,
  confirmOrderError,
  getRecordsRequest,
  getRecordsSuccess,
  getRecordsError,
  resetRecordsState,
} = diagnosticsSlice.actions

export default diagnosticsSlice.reducer
